import React from "react";

function MenuSwitcher({ menuType, foodCount, drinksCount, onSwitch }) {
  return (
    <div className="master-switcher">
      <button
        className={`switch-tab ${menuType === "food" ? "active" : ""}`}
        onClick={() => onSwitch("food")}
        aria-label="Switch to Food Menu"
      >
        <span>FOOD MENU</span>
        <span className="tab-count">{foodCount}</span>
      </button>
      <button
        className={`switch-tab ${menuType === "drinks" ? "active" : ""}`}
        onClick={() => onSwitch("drinks")}
        aria-label="Switch to Drinks Menu"
      >
        <span>DRINKS MENU</span>
        <span className="tab-count">{drinksCount}</span>
      </button>
    </div>
  );
}

export default React.memo(MenuSwitcher);
